import {ActionLink, Label} from "nhsuk-react-components"
import * as React from "react"
import {useContext, useEffect} from "react"
import {AppContext} from "../index"
import {CONFIG_INITIALIZED_KEY} from "./homePage"

const LogoutPage: React.FC = () => {
  const {baseUrl} = useContext(AppContext)

  useEffect(() => {
    sessionStorage.removeItem(CONFIG_INITIALIZED_KEY)
  }, [])

  return (
    <>
      <Label isPageHeading>You have been logged out</Label>
      <Label>Use the link below if you want to login again.</Label>
      <ActionLink href={`${baseUrl}login`}>Login</ActionLink>
    </>
  )
}

export default LogoutPage
